import React from 'react'
import { Link } from 'react-static'
import { TimelineMax, Power2 } from 'gsap'
import PropTypes from 'prop-types'
import { scrollToTop } from '../../helpers'

import Header from '../Header'
import HomeNavButton from './HomeNavButton'

import logo from '../../images/logo-horizontal-white.png'

export default class HomeHeader extends React.Component {
  static propTypes = {
    activeNavItem: PropTypes.string.isRequired,
    navItems: PropTypes.array.isRequired,
    scrollToSection: PropTypes.func.isRequired,
    updateHeaderBg: PropTypes.func.isRequired,
  }

  componentDidMount () {
    this.animateIn()
  }

  animateIn = () => {
    const tl = new TimelineMax()
    tl.staggerTo('.header, .header__logo, .header__nav button, .header__page-link', 0.5, { y: 0, autoAlpha: 1, ease: Power2.easeOut, onComplete: this.props.updateHeaderBg }, 0.03)
  }

  render () {
    const { activeNavItem, navItems, scrollToSection } = this.props
    return (
      <Header className="home-header">
        <img onClick={scrollToTop} className="header__logo" src={logo} alt="Makuch Roofing Logo" />
        <nav className="header__nav">
          { navItems.map((item, i) => (
            <HomeNavButton
              key={i}
              click={scrollToSection}
              active={activeNavItem === item}
            >
              {item}
            </HomeNavButton>
          ))}
        </nav>
        <Link to="/blog">
          <button className="secondary-button header__page-link">View Blog</button>
        </Link>
      </Header>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/home-page/HomeHeader.js